import { BaseComponent } from './../../../../common/components/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FavoriteCustomEvent } from './../../../shared/models/favorite.custom.event';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, takeUntil, delay } from 'rxjs';
import { frontendSettingsSelector } from 'src/app/modules/shared/ngrx.stores/frontend.settings/selectors';
import {
  IAppState,
  IFrontendSettings,
} from 'src/app/modules/shared/ngrx.stores/frontend.settings/states';
import { VisitorEventService } from '../../services/visitor.event.service';
import * as EventQueryCommandActions from 'src/app/modules/event-calendar/ngrx.stores/event.query.command/actions';
import { eventQueryCommandSelector } from 'src/app/modules/event-calendar/ngrx.stores/event.query.command/selectors';
import {
  getRouteUrl,
  routeConfigs,
} from 'src/app/common/constants/route.config';
import { Location } from '@angular/common';
import { VisitorService } from 'src/app/modules/shared/services/visitor.service';
import { SeoService } from '../../../../common/services/seo.service/seo.service';

@Component({
  selector: 'ig-favorite-custom-event-filter',
  templateUrl: './favorite.custom.event.filter.component.html',
  styleUrls: ['./favorite.custom.event.filter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FavoriteCustomEventFilterComponent extends BaseComponent {
  title = 'EVENT CATEGORIES';
  frontendSettings$: Observable<IFrontendSettings | null>;
  @Input() mode: 'expand' | 'dropdown' = 'expand';
  @Output() favSelected = new EventEmitter<any>();

  originLink: string = '';

  constructor(
    public activatedRoute: ActivatedRoute,
    private _router: Router,
    private _store: Store<IAppState>,
    private _eventService: VisitorEventService,
    private _location: Location,
    private _seoService: SeoService,
    public visitorService: VisitorService
  ) {
    super({ activatedRoute });
    this.frontendSettings$ = this._store.pipe(
      takeUntil(this.isDestroyed),
      select(frontendSettingsSelector)
    );

    // set title and selected outline
    this._store
      .pipe(
        takeUntil(this.isDestroyed),
        delay(500),
        select(eventQueryCommandSelector)
      )
      .subscribe((cmd) => {
        this.frontendSettings$.subscribe((settings: IFrontendSettings) => {
          if (!settings) return;

          let originLink = this._location.path().split('ig-custom-events=')[0];
          if (originLink.endsWith('?') || originLink.endsWith('&')) {
            originLink = originLink.slice(0, -1);
          }
          this.originLink = originLink;

          if (cmd?.favoriteEventBtnId) {
            const btn = settings.customSettings.customEvents.find(
              (btn) => btn._id === cmd.favoriteEventBtnId
            );

            if (btn) {
              if (cmd.updateURL !== false) {
                this.title = btn.btnText;
                const currentPath = this._location.path();
                if (currentPath.includes('ig-custom-events=')) {
                  this._location.go(currentPath.split('ig-custom-events=')[0]
                    + `ig-custom-events=${this.visitorService.convertToUrlSafeString(btn.btnText.trim())}-${btn._id}`);
                } else {
                  const connector = currentPath.includes('?') ? '&' : '?';
                  this._location.go(currentPath + `${connector}ig-custom-events=${this.visitorService.convertToUrlSafeString(btn.btnText.trim())}-${btn._id}`);
                }
              } else {
                const currentPath = this._location.path();
                if (!currentPath.includes('ig-custom-events=')) {
                  this.title = btn.btnText;
                }
              }
            }
          }

          if (cmd?.choice) {
            this.title =
              settings.customSettings.customEditorChoice.editorChoiceForEvent;
          }
        });
      });
  }

  clear() {
    this.gotoCategory();
  }

  gotoCategory(btn?: FavoriteCustomEvent) {
    this.title = btn?.btnText || 'EVENT CATEGORIES';
    this._store.dispatch(
      EventQueryCommandActions.setFavoriteEventBtnId({
        favBtnId: btn?._id,
      })
    );

    this.originLink && this._location.go(this.originLink);

    // this.jumpToEventCalendar();
    this.favSelected.emit(btn);
  }

  gotoEditorChoice(text: string) {
    this.title = text;
    this._store.dispatch(
      EventQueryCommandActions.setIsChoice({
        choice: true,
      })
    );

    // this.jumpToEventCalendar();
    this.favSelected.emit(text);
  }

  jumpToEventCalendar() {
    this._router.navigateByUrl(
      getRouteUrl(routeConfigs.visitor.eventCalendar, {
        hubName: this.hubName,
      }),
      { skipLocationChange: this.noChangeUrlWhenRedirect }
    );
  }
}
